import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "user_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};
import BackTitleView from "@com/BackTitleView.vue";
import UploadSinglePicture from "@com/upload/UploadSinglePicture.vue";
import { ref, reactive } from "vue";
import useRoute from "@util/router";
import $ from "@util/base";
import { $msg } from "@ui/msg";
import api from "@api/user";
export default {
  __name: 'UserDetails',

  setup(__props) {
    const baseOptions = ref([]);
    const roleOptions = ref([]);
    getConfig();

    function getConfig() {
      api.base(val => {
        baseOptions.value = val;
      });
      api.roleList(val => {
        roleOptions.value = val;
      });
    }

    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var title = "用户详情";
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "用户详情";
        getData();
      },
      add: () => {
        title = "新增用户";
      },
      modify: () => {
        title = "修改用户";
        getData();
      }
    });

    function getData() {
      api.details(route.query().code, val => {
        form.value = val;
      });
    }

    const formRef = ref('');
    const form = ref({
      name: null,
      avatar: null,
      shopId: null,
      // dataShopList: [],
      roleId: null,
      loginName: null,
      loginPassword: null
    });
    const rules = {
      name: [{
        required: true,
        message: '请输入用户名称',
        trigger: 'blur'
      }],
      avatar: [{
        required: true,
        message: '请上传用户头像',
        trigger: 'blur'
      }],
      shopId: [{
        required: true,
        message: '请选择归属基地',
        trigger: 'change'
      }],
      // dataShopList: [{
      //   type: 'array',
      //   required: true,
      //   message: '请选择数据权限',
      //   trigger: 'change',
      // }],
      roleId: [{
        required: true,
        message: '请选择角色',
        trigger: 'change'
      }],
      loginName: [{
        required: true,
        message: '请输入账号',
        trigger: 'blur'
      }],
      loginPassword: [{
        required: true,
        message: '请输入密码',
        trigger: 'blur'
      }]
    };

    const checkForm = () => {
      formRef.value.validate(valid => {
        if (valid) {
          $.handleCRU(route.query().type, {
            add: () => {
              addData();
            },
            modify: () => {
              modifyData();
            }
          });
        } else {
          return false;
        }
      });
    };

    function addData() {
      api.add(form.value, () => {
        $msg.succ("添加成功");
        back();
      });
    }

    function modifyData() {
      api.update(form.value, () => {
        $msg.succ("修改成功");
        back();
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            rules: rules,
            disabled: _unref(readOnly),
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "用户名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "用户头像",
              prop: "avatar"
            }, {
              default: _withCtx(() => [_createVNode(UploadSinglePicture, {
                modelValue: form.value.avatar,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.avatar = $event),
                disabled: _unref(readOnly),
                width: 120,
                fileSize: _unref($).imgFileSize()
              }, null, 8, ["modelValue", "disabled", "fileSize"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "归属基地",
              prop: "shopId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.shopId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.shopId = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "角色",
              prop: "roleId"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.roleId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.roleId = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleOptions.value, (item, index) => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: index,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "账号",
              prop: "loginName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.loginName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.loginName = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _withDirectives(_createVNode(_component_el_form_item, {
              label: "密码",
              prop: "loginPassword"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.loginPassword,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.loginPassword = $event),
                type: "password",
                "show-password": "",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }, 512), [[_vShow, _unref(route).query().type == 'add']])]),
            _: 1
          }, 8, ["model", "disabled"])])])])]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: checkForm,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, !_unref(readOnly)]])]),
        _: 1
      })]);
    };
  }

};